import type { RouteRecordRaw } from 'vue-router'
import { ROUTE_ROLES } from '@/utils/permissions'

const routes: RouteRecordRaw[] = [
  {
    path: '/trade/order',
    name: 'TradeOrder',
    component: () => import('@/views/trade/order.vue'),
    meta: {
      title: '委托监控',
      permission: 'trade:order'
    }
  },
  {
    path: '/trade/fill',
    name: 'TradeFill',
    component: () => import('@/views/trade/fill.vue'),
    meta: {
      title: '成交监控',
      permission: 'trade:fill'
    }
  },
  {
    path: '/trade/execution-repair',
    name: 'TradeExecutionRepair',
    component: () => import('@/views/trade/executionRepair.vue'),
    meta: {
      title: '成交修复',
      permission: 'trade:repair',
      roles: ROUTE_ROLES.tradeRepair
    }
  },
  {
    path: '/trade/execution-reconciliation',
    name: 'TradeExecutionReconciliation',
    component: () => import('@/views/trade/executionReconciliation.vue'),
    meta: {
      title: '成交对账',
      permission: 'trade:repair',
      roles: ROUTE_ROLES.tradeRepair
    }
  }
]

export default routes
